import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { hasSubmitSucceeded } from 'redux-form'
import { getMessage } from '../../actions'
import NotFound from '../../common/NotFound'
import Spinner from '../../common/Spinner'
import NewMessageForm from '../../common/NewMessageForm'
import { markMessageAsRead } from '../../actions'
import { sendMessage } from '../../api'
import Card from 'material-ui/Card'
import { themeColors } from '../../styles/theme'
import DateRange from 'material-ui/svg-icons/action/date-range'
import moment from 'moment'
import Mail from 'material-ui/svg-icons/content/mail'

const styles = {
  containerStyle: {
    padding: 10,
  },
  from: {
    fontSize: 14,
    fontWeight: 400,
    paddingBottom: 20,
    float: 'left',
    color: themeColors.energized,
    display: 'flex',
  },
  date: {
    color: themeColors.energized,
    display: 'flex',
    float: 'right',
    cursor: 'default',
  },
  icons: {
    position: 'relative',
    top: '-2px',
    paddingRight: 3,
  },
  message: {
    fontSize: 18,
    color: 'rgba(0, 0, 0, 0.5)',
    clear: 'both',
    wordBreak: 'break-word',
  },
}

class MessageDetail extends PureComponent {
  componentWillMount() {
    if (!this.props.message) {
      this.props.getMessage(this.props.match.params.id)
    } else {
      this.markMessageAsRead(this.props.message)
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.match.params.id !== nextProps.match.params.id) {
      this.props.getMessage(nextProps.match.params.id)
    }
    if (this.props.message !== nextProps.message) {
      this.markMessageAsRead(nextProps.message)
    }
  }

  markMessageAsRead = message => {
    const { user } = this.props
    if (message.mittente.id !== user.id && !message.read) {
      this.props.markMessageAsRead(message.id)
    }
  }

  handleNewMessageSubmit = ({ text }, dispatch) => {
    const { target, accessToken } = this.props
    // TODO: Handle error
    return (
      // TODO: Use makeAuthenticatedApi instead
      sendMessage(accessToken)(target.id, text)
        // FIXME: Bugged shit replace \w onSubmitSuccess redux-form native handler
        .then(newMessage => {
          // TODO FIX API RETRIEVE INSERT ID!!!
          // dispatch new messaged sended...
          // FIXME temporanery trick to get insert id
          // getMessages(user.token)().then(messages => {
          //   console.log(messages[0])
          // })
        })
    )
  }

  render() {
    const { loading, message, newMessageSended } = this.props

    return (
      <div className="padding">
        <Card containerStyle={styles.containerStyle}>
          {loading && <Spinner centered />}

          {!loading && !message && <NotFound />}

          {message &&
            <div>
              <div
                style={{
                  paddingBottom: 25,
                  borderBottom: '0.1px solid #5e7288',
                }}>
                <div style={styles.from}>
                  <Mail style={styles.icons} color={themeColors.energized} />
                  Da
                  {' '}
                  <span style={{ paddingLeft: 5, fontWeight: 'bold' }}>
                    {' '}{message.mittente.username}
                  </span>
                </div>
                <div style={styles.date}>
                  <DateRange
                    color={themeColors.energized}
                    style={styles.icons}
                  />
                  {moment(message.created_at).format('DD/MM/YYYY')}
                </div>
              </div>
              <div style={styles.message}>{message.testo}</div>
            </div>}

          {message && <NewMessageForm onSubmit={this.handleNewMessageSubmit} />}

          {newMessageSended && <div>Messaggio Inviato!</div>}
        </Card>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const message = state.messages.data[ownProps.match.params.id]
  const loading = state.messages.viewedMessage.loading
  const user = state.auth.user

  // Target for a new message
  let target = null
  if (message) {
    target = message.mittente.id === user.id
      ? message.destinatario
      : message.mittente
  }

  return {
    newMessageSended: hasSubmitSucceeded('new-message-form')(state),
    accessToken: state.auth.accessToken,
    message,
    user,
    loading,
    target,
  }
}

export default connect(mapStateToProps, {
  getMessage,
  markMessageAsRead,
})(MessageDetail)



// WEBPACK FOOTER //
// ./src/pages/Messages/MessageDetail.js